const startTrial = async (AdoxxInstance) =>
{
    
    try
    {
        const response = await fetch(`https://0nsyxtmmk4.execute-api.eu-central-1.amazonaws.com/licenses`,
        {
            method: 'POST',
            headers:
            {
                'Content-Type': 'text/plain'
            },
            body: JSON.stringify(
            {
                "AdoxxInstance": AdoxxInstance
            })
        });

        if (!response.ok)
        {
            throw new Error('Network response was not ok ' + response.statusText);
        }

        const data = await response.json();
        return data;
    }
    catch (error)
    {
        console.error('Fetch error:', error);
        throw error;
    }
}

export default startTrial;